/**
 * Motion tokens — single source of truth for timings/easings so micro-
 * interactions and route transitions stay consistent instead of scattering
 * `duration-200`/ad-hoc easings across the app.
 *
 * Route transitions animate OPACITY ONLY (no transform) on purpose: a
 * transform on the page wrapper would create a containing block and break
 * `position: sticky` headers and `h-[calc(...)]` canvas layouts. Keep it fades.
 */

export const DURATION = {
  fast: 0.12,
  base: 0.18,
  slow: 0.28,
} as const;

// Standard ease-out curve (matches Tailwind's ease-out feel).
export const EASE_OUT = [0.16, 1, 0.3, 1] as const;

/** Framer Motion variants for page/route transitions (opacity only). */
export const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
} as const;

export const pageTransition = {
  duration: DURATION.base,
  ease: EASE_OUT,
} as const;

/** Subtle rise-in for lists/cards entering. Use sparingly. */
export const riseVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 4 },
} as const;
